import { getStoreNames, saveItem, getAllItems, deleteItem } from './dbService';

const SALAIRES_STORE = getStoreNames().SALAIRES;

export async function saveSalaire(eventId, salaire) {
  return await saveItem('salaires', { eventId, salaire: parseFloat(salaire) || 0 });
}

export async function getSalaire(eventId) {
  const all = await getAllItems(SALAIRES_STORE);
  const found = all.find(s => s.eventId === eventId);
  return found ? found.salaire : 0;
}

export async function getAllSalaires() {
  return await getAllItems(SALAIRES_STORE);
}

export async function deleteSalaire(eventId) {
  return await deleteItem(SALAIRES_STORE, eventId);
}